
// add params to url
const addParamsToUrl = (url, params) => {
    const urlObject = new URL(url);
    Object.keys(params).forEach((key) => {
        urlObject.searchParams.set(key, params[key]);
    });
    return urlObject.toString();
};

export default addParamsToUrl;